import incidentsOverview from './incidentsOverview.json';

import filterIncidents from './widgets/filterIncidents.json';
import filterCausingProduct from './widgets/filterCausingProduct.json';
import filterCausingService from './widgets/filterCausingService.json';
import filterFiscalQuarter from './widgets/filterFiscalQuarter.json';

import summaryIncidentsPriority from './widgets/summaryIncidentsPriority.json';
import incidentsPie from './widgets/incidentsPie.json';
import incidentsPriorityColumnchart from './widgets/incidentsPriorityColumnchart.json';
import incidentCausedDataTable from './widgets/incidentsCausedDataTable.json';
import incidentsByServicePie from './widgets/incidentsByServicePie.json';
import incidentsByCauseCodePie from './widgets/incidentsByCauseCodePie.json';
import incidentsByCauseCodeStack from './widgets/incidentsByCauseCodeStack.json';
import incidentsByServiceStack from './widgets/incidentsByServiceStack.json';
import incidentsPriorityStack from './widgets/incidentsPriorityStack.json';
import incidentsByProductPie from './widgets/incidentsByProductPie.json';
import incidentsByProductStack from './widgets/incidentsByProductStack.json';

export default [
  incidentsOverview,
  filterIncidents,
  filterCausingProduct,
  filterCausingService,
  filterFiscalQuarter,
  summaryIncidentsPriority,
  incidentsPie,
  incidentsPriorityColumnchart,
  incidentCausedDataTable,
  incidentsByServicePie,
  incidentsByCauseCodePie,
  incidentsByCauseCodeStack,
  incidentsByServiceStack,
  incidentsPriorityStack,
  incidentsByProductPie,
  incidentsByProductStack,
];
